export interface UiState {
    globalLoading: boolean;
    sidenavOpen: boolean;
    leftNav: any[];
    rightNav: any[];
    searchBoxVisible: boolean;
    navLoading: boolean;
    buildNumber: string;
    buildDate: string;
    versionNumber: string;
}

export const initialUiState: UiState = {
    globalLoading: false,
    sidenavOpen: true,
    leftNav: [],
    rightNav: [],
    searchBoxVisible: false,
    navLoading: false,
    buildNumber: '',
    buildDate: '',
    versionNumber: '',
};
